<template>
  <!--<el-row :gutter="20" class="head-row" justify="space-around" type="flex">-->
    <!--<el-col :span="groupDivSpan">-->
      <!--<div class="head-div" style="background-color: #3190e8;">-->
        <!--<p class="head-title">我是机构</p>-->
        <!--<el-select v-show="!showGroupLabel" v-model="selectGroupValue" placeholder="请选择机构" class="head-select">-->
          <!--<el-option-->
            <!--v-for="item in groupList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--:disabled="item.disabled">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <!--<p v-show="showGroupLabel" class="head-label">{{selectGroupName}}</p>-->
      <!--</div>-->
      <!--<el-button type="success" round class="head-btn" @click="enterGroupSystem">机构认证</el-button>-->
    <!--</el-col>-->
    <!--<el-col :span="teaDivSpan">-->
      <!--<div class="head-div" style="background-color: #C55252;">-->
        <!--<p class="head-title">我是老师</p>-->
        <!--<el-select v-show="!showTeaLabel" v-model="selectTeaValue" placeholder="请选择机构" class="head-select">-->
          <!--<el-option-->
            <!--v-for="item in teaList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--:disabled="item.disabled">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <!--<p v-show="showTeaLabel" class="head-label">{{selectTeaName}}</p>-->
      <!--</div>-->
      <!--<el-button type="success" round class="head-btn" @click="enterTeaSystem">进入课表</el-button>-->
    <!--</el-col>-->
    <!--<el-col :span="assistantDivSpan">-->
      <!--<div class="head-div" style="background-color: #C55252;">-->
        <!--<p class="head-title">我是助教</p>-->
        <!--<el-select v-show="!showAssistantLabel" v-model="selectAssistantValue" placeholder="请选择机构" class="head-select">-->
          <!--<el-option-->
            <!--v-for="item in assistantList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--:disabled="item.disabled">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <!--<p v-show="showAssistantLabel" class="head-label">{{selectAssistantName}}</p>-->
      <!--</div>-->
      <!--<el-button type="success" round class="head-btn" @click="enterAssistantSystem">开始盯课</el-button>-->
    <!--</el-col>-->
    <!--<el-col :span="stuDivSpan">-->
      <!--<div class="head-div" style="background-color: #37A39D;">-->
        <!--<p class="head-title">我是学生</p>-->
        <!--<el-select v-show="!showStuLabel" v-model="selectStuValue" placeholder="请选择机构" class="head-select">-->
          <!--<el-option-->
            <!--v-for="item in stuList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--:disabled="item.disabled">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <!--<p v-show="showStuLabel" class="head-label">{{selectStuName}}</p>-->
      <!--</div>-->
      <!--<el-button type="success" round class="head-btn" @click="enterStuSystem">开始学习</el-button>-->
    <!--</el-col>-->
  <!--</el-row>-->
  <div>
    <div class="identity-super-bg">
      <div class="identity-bg" v-bind:style="{width: identityWidth + 'px'}">
        <identity-item v-for="(item,index) in identityList"
                       class="identity-item"
                       @enterBtnClick="identityItemEnterBtnClick"
                       v-bind:identityItemInfo="item"
                       v-bind:style="index === 0 ?{width: identityItemWidht + 'px'} : {width: identityItemWidht + 'px','margin-left': identityItemGap + 'px'}">

        </identity-item>
      </div>
    </div>
  </div>
</template>

<script>
import IdentityItem from '../../components/login/IdentityItem'
export default {
  name: 'SelectIdentity',
  components: {IdentityItem},
  data () {
    return {
      identityWidth: 0,
      identityItemWidht: 0,
      identityItemGap: 0,
      identityList: [],
      groupDivSpan: 6,
      teaDivSpan: 6,
      stuDivSpan: 6,
      assistantDivSpan: 6,
      groupList: [],
      teaList: [],
      stuList: [],
      assistantList: [],
      selectGroupValue: '',
      selectGroupName: '',
      selectTeaValue: '',
      selectTeaName: '',
      selectStuValue: '',
      selectStuName: '',
      selectAssistantValue: '',
      selectAssistantName: '',
      showGroupLabel: false,
      showTeaLabel: false,
      showStuLabel: false,
      showAssistantLabel: false
    }
  },
  created () {
    this.$api.login.getIdentity().then((res) => {
      if (res.code === 0) {
        let identityInfo = res.data
        let adminList = identityInfo.admin
        let teaList = identityInfo.teacher
        let stuList = identityInfo.student
        let assistantList = identityInfo.assistant
        if (adminList === undefined && teaList === undefined && assistantList === undefined && stuList.length === 1) {
          this.selectStuValue = stuList[0].id
          this.enterStuSystem()
          return
        } else if (adminList === undefined && stuList === undefined && assistantList === undefined && teaList.length === 1) {
          this.selectTeaValue = teaList[0].id
          this.enterTeaSystem()
          return
        } else if (teaList === undefined && stuList === undefined && assistantList === undefined && adminList.length === 1) {
          this.selectGroupValue = adminList[0].id
          this.enterGroupSystem()
          return
        } else if (teaList === undefined && stuList === undefined && adminList === undefined && assistantList.length === 1) {
          this.selectAssistantValue = assistantList[0].id
          this.enterAssistantSystem()
          return
        }
        // 不是一个机构并且一种身份，展示选择界面
        let identityCount = 0
        if (adminList === undefined) {
          this.groupDivSpan = 0
        } else {
          identityCount = identityCount + 1
          this.addIdentityItem('group',adminList)
          this.groupDivSpan = 6
          this.groupList = adminList
          if (this.groupList.length > 1) {
            this.showGroupLabel = false
          } else if (this.groupList.length === 1) {
            this.showGroupLabel = true
            this.selectGroupName = this.groupList[0].name
            this.selectGroupValue = this.groupList[0].id
          }
        }
        if (teaList === undefined) {
          this.teaDivSpan = 0
        } else {
          identityCount = identityCount + 1
          this.addIdentityItem('teacher',teaList)
          this.teaDivSpan = 6
          this.teaList = teaList
          if (this.teaList.length > 1) {
            this.showTeaLabel = false
          } else if (this.teaList.length === 1) {
            this.showTeaLabel = true
            this.selectTeaName = this.teaList[0].name
            this.selectTeaValue = this.teaList[0].id
          }
        }
        if (assistantList === undefined) {
          this.assistantDivSpan = 0
        } else {
          identityCount = identityCount + 1
          this.addIdentityItem('assistant',assistantList)
          this.assistantDivSpan = 6
          this.assistantList = assistantList
          if (this.assistantList.length > 1) {
            this.showAssistantLabel = false
          } else if (this.assistantList.length === 1) {
            this.showAssistantLabel = true
            this.selectAssistantName = this.assistantList[0].name
            this.selectAssistantValue = this.assistantList[0].id
          }
        }
        if (stuList === undefined) {
          this.stuDivSpan = 0
        } else {
          identityCount = identityCount + 1
          this.addIdentityItem('student',stuList)
          this.stuDivSpan = 6
          this.stuList = stuList
          if (this.stuList.length > 1) {
            this.showStuLabel = false
          } else if (this.stuList.length === 1) {
            this.showStuLabel = true
            this.selectStuName = this.stuList[0].name
            this.selectStuValue = this.stuList[0].id
          }
        }

        if(identityCount === 0) {
          identityCount = 4
          this.addIdentityItem('group',[])
          this.addIdentityItem('assistant',[])
          this.addIdentityItem('teacher',[])
          this.addIdentityItem('student',[])
        }

        if (identityCount === 3 || identityCount === 4) {
          this.identityWidth = identityCount * 272 + (identityCount - 1) * 22
          this.identityItemWidht = 272
          this.identityItemGap = 22
        } else if (identityCount === 2 || identityCount === 1) {
          this.identityWidth = identityCount * 400 + (identityCount - 1) * 60
          this.identityItemWidht = 400
          this.identityItemGap = 60
        }
      }
    })
  },
  methods: {
    identityItemEnterBtnClick (item, type) {
      if (type === 'group') {
        this.selectGroupValue = item.id
        this.enterGroupSystem()
      } else if (type === 'assistant') {
        this.selectAssistantValue = item.id
        this.enterAssistantSystem()
      } else if (type === 'teacher') {
        this.selectTeaValue = item.id
        this.enterTeaSystem()
      } else if (type === 'student') {
        this.selectStuValue = item.id
        this.enterStuSystem()
      }
    },
    addIdentityItem (type, list) {
      if (list.length > 0) {
        list[0].select = true
      }
      let itemObj = {type:type, list:list}
      this.identityList.push(itemObj)
    },
    enterGroupSystem () {
      if (this.selectGroupValue === '') {
        this.$message.error('请选择要登录的机构')
        return
      }
      let identityInfo = {id: this.selectGroupValue, type: 'admin'}
      this.$api.login.selectIdentity(identityInfo).then((res) => {
        if (res.code === 0) {
          console.log('跳入管理员系统')
          this.$store.commit('setUserType', 3)
          this.$router.replace('/')
        }
      })
    },
    enterAssistantSystem () {
      if (this.selectAssistantValue === '') {
        this.$message.error('请选择要登录的机构')
        return
      }
      let identityInfo = {id: this.selectAssistantValue, type: 'assistant'}
      this.$api.login.selectIdentity(identityInfo).then((res) => {
        if (res.code === 0) {
          console.log('跳入助教系统')
          this.$store.commit('setUserType', 2)
          this.$router.replace('/assistantIndex')
        }
      })
    },
    enterTeaSystem () {
      if (this.selectTeaValue === '') {
        this.$message.error('请选择要登录的机构')
        return
      }
      let identityInfo = {id: this.selectTeaValue, type: 'teacher'}
      this.$api.login.selectIdentity(identityInfo).then((res) => {
        if (res.code === 0) {
          console.log('跳入老师系统')
          this.$store.commit('setUserType', 1)
          this.$router.replace('/teaIndex')
        }
      })
    },
    enterStuSystem () {
      if (this.selectStuValue === '') {
        this.$message.error('请选择要登录的机构')
        return
      }
      let identityInfo = {id: this.selectStuValue, type: 'student'}
      this.$api.login.selectIdentity(identityInfo).then((res) => {
        if (res.code === 0) {
          console.log('跳入学生系统')
          this.$store.commit('setUserType', 0)
          this.$router.replace('/stuIndex')
        }
      })
    }
  }
}
</script>

<style scoped>
  .identity-bg{
    margin: 0 auto;
  }
  .identity-super-bg{
    width: 100%;
    height: 300px;
    position: absolute;
    top: -50px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .identity-item{
    height: 300px;
    float:left;
    display:inline
  }

.head-row{
  padding-top: 100px;
  padding-right: 80px;
  padding-left: 80px;
  text-align: center;
}
.head-div{
  height: 200px;
  text-align: center;
}
.head-title{
  color: #FFFFFF;
  font-size: 26px;
  padding-top: 20px;
}
.head-select{
  padding-top: 20px;
  width: 280px;
}
.head-label{
  color: #FFFFFF;
  font-size: 20px;
  padding-top: 20px;
}
.head-btn{
  width: 80%;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/login/SelectIdentity.vue